<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      深圳湾公园站<br>
站点介绍<br>
深圳湾公园站设于海园二路与滨海大道交界口处，沿滨海大道东西向布置,站位北侧为欢乐海岸及港大深圳医院，南侧为深圳湾滨海公园及红树林自然保护区。深圳湾公园站的采光天井和墙面设计与地面南侧深圳湾滨海公园融为一体，采用绿色作为基调。该站为地下站。<br>
运营时刻表(工作日)<br><br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:10	23:43	9号线	3分50秒	5分55秒<br>
文锦	06:16	23:26	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:10	23:43	9号线	4分25秒	5分55秒<br>
文锦	06:16	23:26	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:04	00:43	9号线	4分钟	5分55秒<br>
文锦	06:15	00:26	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
滨海大道南侧（西）、深圳湾公园<br><br>
C出入口:<br>
深圳湾公园<br><br>
D1出入口:<br>
海园一路、港大医院<br><br>
D2出入口:<br>
滨海大道南侧（东）、深圳湾公园<br><br>
E出入口:<br>
滨海大道北侧、海园二路、深圳市旅游信息中心、海洋奇梦馆、华侨城湿地、曲水湾<br><br>
公交换乘信息<br><br>
D1出入口:<br>
公交站名： 深圳湾公园地铁站①<br>
339路、M105、M106、M133<br><br>
E出入口:<br><br>
公交站名： 深圳湾公园地铁站②<br>
E12、M347、M463、M519、滨海休闲观光假日专线<br><br>
D1出入口:<br>
公交站名： 港大医院总站<br>
E37<br><br>
D2出入口:<br>
公交站名： 深圳湾公园地铁站<br>
339路、M347路、M463、M519、E12、滨海休闲观光假日专线、M133<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>